import axios from 'axios'

export default class AuthApi {

  constructor ({ client, authToken }) {
    if (client) {
      this.client = client
    } else {
      this.client = axios.create({
        baseURL: '/auth',
        headers: { 'Content-Type': 'application/json' },
      })
    }
    if (authToken) { this.authToken = authToken }
  }

  refreshToken () {
    return this.client.get('/refresh-token')
  }

  postLogin (data) {
    return this.client.post('/login', data)
  }

  getLogout () {
    return this.client.get('/logout')
  }

  postFacebookToken (data) {
    return this.client.post('/login/facebook', data)
  }

  postSignup (_data) {
    const data = Object.assign({}, _data, {
      promotionalPreference: !!_data.promotionalPreference,
    })

    return this.client.post('/signup', data)
  }

  postSignupWithFacebook (data) {
    return this.client.post('/signup/facebook', data)
  }

  getGeoIp () {
    return this.client.get('/geoip')
  }

  getClearLegacy () {
    return this.client.get('/clear-legacy')
  }

  requestPasswordReset (email, redirectURI) {
    return this.client.post('/password-reset', { email: email, redirect_uri: redirectURI })
  }

  getConsentMatrix (isoCode) {
    return axios.get(`/auth/consents-matrix/${isoCode}`)
  }

  getConsentStatus (params) {
    const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
    return axios.get(`/auth/consents-status?${queryString}`)
  }

  updateConsents ({ consent_matrix_version, region, consents }) {
    const { authToken } = this
    const headers = {
      'Content-Type': 'application/json',
    }
    if (authToken) { headers.Authorization = `Bearer ${authToken}` }

    const consentsApi = axios.create({
      baseURL: '/auth',
      headers: headers,
    })

    return consentsApi.post('/update-consents', { consent_matrix_version, region, consents })
  }

  findUserByEmail (email) {
    return axios.get(`/auth/find-user-by-email/${email}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/api.js